module.exports = __webpack_public_path__ + "img/sr09_samurai02_shop.e2fc8f2f.png";